import { useEffect, useState } from "react"

import SettingTitleBox from "../../components/SettingTitleBox";
import SettingSideBox from "../../components/SettingSideBox";

import { AiFillCheckCircle, AiFillEye } from "react-icons/ai"
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const ChangePasswordBox = () => {

  const [form, setForm] = useState({
    oldPassword: '',
    oldPasswordShown: false,
    newPassword: '',
    newPasswordShown: false,
    newPasswordConfirmation: '',
    newPasswordConfirmationShown: false
  })

  return (
    <div
      className="p-5 py-8 rounded-lg bg-white space-y-5"
      style={{
        width: '469px',
        fontSize: '13px'
      }}
    >
      
      <div
        className="space-y-1"
      >
        <div
          className=""
          style={{
            fontSize: '12px'
          }}
        >
          Password Lama
        </div>
        <div
          className="relative"
        >
          <input 
            type={form.oldPasswordShown ? 'text' : 'password'}
            className="w-full p-1.5 pr-10 border border-gray-300 rounded-md outline-green-300"
            placeholder="Password Lama"
            value={form.oldPassword}
            onChange={e => setForm({ ...form, oldPassword: e.target.value })}
          />
          <div class="flex absolute inset-y-0 right-3 items-center pl-3">
            <button
              onClick={() => setForm({ ...form, oldPasswordShown: !form.oldPasswordShown })}
            >
              <AiFillEye className="w-5 h-5"/>
            </button>
          </div>
        </div>
      </div>
      <div
        className="space-y-1"
      >
        <div
          className=""
          style={{
            fontSize: '12px'
          }}
        >
          Password Baru
        </div>
        <div
          className="relative"
        >
          <input 
            type={form.newPasswordShown ? 'text' : 'password'}
            className="w-full p-1.5 pr-10 border border-gray-300 rounded-md outline-green-300"
            placeholder="Password Baru"
            value={form.newPassword}
            onChange={e => setForm({ ...form, newPassword: e.target.value })}
          />
          <div class="flex absolute inset-y-0 right-3 items-center pl-3">
            <button
              onClick={() => setForm({ ...form, newPasswordShown: !form.newPasswordShown })}
            >
              <AiFillEye className="w-5 h-5"/>
            </button>
          </div>
        </div>
      </div>
      <div
        className="space-y-1"
      >
        <div
          className=""
          style={{
            fontSize: '12px'
          }}
        >
          Konfirmasi Password Baru
        </div>
        <div
          className="relative"
        >
          <input 
            type={form.newPasswordConfirmationShown ? 'text' : 'password'}
            className="w-full p-1.5 pr-10 border border-gray-300 rounded-md outline-green-300"
            placeholder="Konfirmasi Password Baru"
            value={form.newPasswordConfirmation}
            onChange={e => setForm({ ...form, newPasswordConfirmation: e.target.value })}
          />
          <div class="flex absolute inset-y-0 right-3 items-center pl-3">
            <button
              onClick={() => setForm({ ...form, newPasswordConfirmationShown: !form.newPasswordConfirmationShown })}
            >
              <AiFillEye className="w-5 h-5"/>
            </button>
          </div>
        </div>
      </div>
      <div>
        <button
          className="w-full py-1.5 bg-green-800 text-white font-bold rounded-md"
        >
          SIMPAN
        </button>
      </div>

    </div>
  )

}


const SettingPasswordPage = () => {
  useEffect(() => {
    document.body.style.backgroundColor = '#232745';
  }, []);

  return (
    <>
    <Navbar />
    <div
      className="w-full space-y-10"
      style={{
        backgroundColor: '#232745',
        minHeight: '800px'
      }}
    >
      <SettingTitleBox
        title={'Edit Password'}
      />
      <div
        className="flex justify-center"
        style={{
          backgroundColor: '#232745'
        }}
      >
        <div
          className="flex space-x-5"
          style={{
            width: '1199px'
          }}
        >
          
          <SettingSideBox 
            activeMenu={'password'}
          />
          <div className="flex-1">
            <ChangePasswordBox />
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  )
}

export default SettingPasswordPage;